import { gql } from "@apollo/client"

const GET_DASHBOARD_TEACHER_SCHEDULE = gql`
  query ($input: TeacherEventScheduleInput!, $first: Int!) {
    teacherEventSchedule(input: $input, first: $first) {
      data {
        id
        lesson
        starts_at
        ends_at
        student
        parent
        attendance_status
      }
    }
  }
`

export { GET_DASHBOARD_TEACHER_SCHEDULE }
